export default __webpack_public_path__ + "img/jtc/jtc5_src.jpg";